import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePutPersonsByIdMutation } from '@client/api';
import { Skeleton } from '@client/toolkit';

import { useSession } from '../../../../../hooks';
import { PersonFormData, UserForm } from '../../../../../pods/users/components';

export type ProfileEditModalProps = {
  open: boolean;
  onAfterSubmit: () => void;
  onClose: () => void;
};

export function ProfileEditModal({ open, onAfterSubmit, onClose }: ProfileEditModalProps) {
  const { t, ready } = useTranslation('users');

  const { sessionPerson } = useSession();

  const [putPerson] = usePutPersonsByIdMutation();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const id = useMemo(() => sessionPerson!.id, [sessionPerson]);

  const handleSubmit = async (data: PersonFormData) => {
    await putPerson({
      id,
      body: { ...data },
    }).unwrap();

    onAfterSubmit();
  };

  return (
    <UserForm
      open={open}
      title={ready ? t('userEdit.title') : <Skeleton variant="text" className="w-[120px]" />}
      onSubmit={handleSubmit}
      onClose={onClose}
      person={sessionPerson ?? undefined}
      edit
      hideAdvancedFields
    />
  );
}
